import React from 'react';

interface SpinnerProps{
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
  className
}) => {
  return (
    <div className={` animate-spin   `}>

    <svg  xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
  <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM1.8 12C1.8 17.6333 6.36669 22.2 12 22.2C17.6333 22.2 22.2 17.6333 22.2 12C22.2 6.36669 17.6333 1.8 12 1.8C6.36669 1.8 1.8 6.36669 1.8 12Z" fill="#D9D9D9"/>
  <path d="M9.12711 22.7218C8.99846 23.2019 8.50348 23.4901 8.03435 23.3258C5.93761 22.5917 4.0797 21.2874 2.67424 19.5518C1.07945 17.5824 0.149065 15.1587 0.016444 12.628C-0.116177 10.0973 0.555769 7.58961 1.93598 5.46429C3.15233 3.59129 4.86373 2.10001 6.87226 1.15074C7.32165 0.938347 7.84404 1.17319 8.02217 1.63724C8.20029 2.10128 7.96628 2.6183 7.51974 2.83662C5.86505 3.64564 4.45483 4.89055 3.44558 6.44465C2.2724 8.25117 1.70125 10.3827 1.81398 12.5338C1.9267 14.6849 2.71753 16.7451 4.0731 18.4191C5.23927 19.8592 6.77188 20.9499 8.50207 21.5815C8.96898 21.7519 9.25576 22.2417 9.12711 22.7218Z" fill="currentColor"/>
</svg>
</div>
  );
};

export default Spinner;